import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://ptitservices-pro.com";

export const Seo = ({ title, description, path = "/", noindex = false }) => (
  <Helmet>
    <html lang="fr" />
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    <link rel="canonical" href={`${SITE}${path}`} />
    <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
    <meta property="og:site_name" content="PTITSERVICES-PRO" />
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta property="og:type" content="website" />
    <meta property="og:url" content={`${SITE}${path}`} />
    <meta property="og:image" content={`${SITE}/logo.png`} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    <meta name="twitter:image" content={`${SITE}/logo.png`} />
  </Helmet>
);

export default Seo;
